// extracted by mini-css-extract-plugin
export default {"root":"search_root__npKAi","lightBackground":"search_lightBackground__nNwDZ","input":"search_input__l9TSq","icon":"search_icon__DOZJr","darkIcon":"search_darkIcon__WP+gI"};